import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/index.css";
import AppRoot from "./App";
import reportWebVitals from "./reportWebVitals";
import './utils/localisation';

ReactDOM.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
